import { ChangeDetectionStrategy, ChangeDetectorRef, Component, signal } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators, ReactiveFormsModule } from '@angular/forms';
import { NewsletterService } from '@app/sections/front/newsletter/newsletter.service';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { handleServerSideValidation } from '@back/shared/utils/server-side-validation';
import { SettingsService } from '@app/services/settings/settings.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { LandingWallpaperComponent } from '../../../shared/landing-wallpaper/landing-wallpaper.component';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LandingWallpaperComponent, ReactiveFormsModule, MatButtonModule, MatRadioModule]
})
export class NewsletterComponent {

  submitted = signal<boolean>(false)
  form: UntypedFormGroup = new UntypedFormGroup({
    first_name: new UntypedFormControl('', Validators.required),
    last_name: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    profile_privacy: new UntypedFormControl(null, [Validators.nullValidator]),
    third_part_privacy: new UntypedFormControl(null, [Validators.nullValidator]),
    marketing_privacy: new UntypedFormControl(null, [Validators.nullValidator])
  })

  constructor(
    private newsletterService: NewsletterService,
    public settingsService: SettingsService,
    private cdr: ChangeDetectorRef,
    private toast: ToastrService
  ) {
  }

  submitForm() {
    this.submitted.set(true);

    if (this.form.invalid) {
      this.toast.error('Controlla eventuali errori nel modulo e invia di nuovo!');
      return;
    }

    this.newsletterService.addSubscriber(this.form.value).pipe(take(1)).subscribe(() => {
      this.toast.success("Ti sei iscritto con successo");
      this.form.reset({
        first_name: '',
        last_name: '',
        email: '',
        profile_privacy: null,
        third_part_privacy: null,
        marketing_privacy: null
      });
      this.submitted.set(false); // in order to revalidate the form from beginning
    },(error) => {
        if (error instanceof HttpErrorResponse) {
          this._handleHttpError(error, this.form);
        }
        this.cdr.markForCheck();
      }
    );
  }

  isInvalid(form: UntypedFormGroup, control: string): boolean | undefined {
    return (this.submitted() && form.get(control)?.errors) as boolean;
  }

  getError(form: UntypedFormGroup, control: string): ValidationErrors | null {
    return (form.get(control)?.errors) as ValidationErrors;
  }

  getValue(form: UntypedFormGroup, control: string): any {
    return form.get(control)?.value;
  }

  serverSideError(form: UntypedFormGroup, control: string): string | null {
    return form.get(control)?.getError('serverSideError');
  }

  private _handleHttpError(error: Error, form: UntypedFormGroup): void {
    if (!(error instanceof HttpErrorResponse)) {
      return;
    }

    if (error.status === 401) {
      this.toast.error(error.error.message);
    }

    const unhandledErrors = handleServerSideValidation(error, form);
    if (unhandledErrors) {
      this.toast.error(error.statusText, unhandledErrors);
    }
  }


}
